import { TemplateFilterOption } from './context/TemplatesContext.types'

export const TEMPLATE_TYPES_FILTERS: TemplateFilterOption[] = [
    {
        label: 'Popular',
        value: 'popular',
    },
    {
        label: 'Other',
        value: 'non-popular',
    },
]
